import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const Dashboard = () => {
    // --- PHASE 2: IDENTITY & ROLES ---
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    const username = storedUser.username || 'Player';
    const userRole = storedUser.role || 'player';
    const isAdmin = userRole === 'admin';

    // --- STATE MANAGEMENT ---
    const [history, setHistory] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [circuits, setCircuits] = useState([]);
    const navigate = useNavigate();
    const [playerStats, setPlayerStats] = useState({ 
    overall: { tournamentsPlayed: 0, totalWinPts: 0, tournamentWins: 0, rankTitle: 'Unranked' },
    gameStats: {},
    tournamentHistory: [],
    circuitHistory: []
});
    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

const fetchHistory = async () => {
        try {
            const response = await api.get('/tournaments');
            setHistory(response.data);
            
            const circuitRes = await api.get('/circuits');
            setCircuits(circuitRes.data);

            // Fetch my global stats!
            const statsRes = await api.get('/tournaments/stats/me');
            console.log("🔥 STATS RECEIVED FROM BACKEND:", statsRes.data); // <-- ADD THIS
            
            // Only set stats if we actually got the right data structure back
            if (statsRes.data && statsRes.data.overall) {
                setPlayerStats(statsRes.data);
            }
        } catch (err) {
            console.error("❌ Failed to fetch history or stats:", err);
        }
    };
const createCircuit = async () => {
    const circuitName = window.prompt("Enter a name for your new Championship Circuit:");
    if (!circuitName) return;
    try {
        const { data } = await api.post('/circuits', { name: circuitName });
        navigate(`/circuit/${data._id}`); // Instantly go to the new leaderboard!
    } catch (err) {
        alert("Failed to create circuit.");
    }
};
    // --- DATA FILTERING ---
   const filteredHistory = history.filter(t => 
    (t.name || 'Untitled Tournament').toLowerCase().includes((searchTerm || '').toLowerCase())
);
    const completedTournaments = filteredHistory.filter(t => t.status === 'completed');
    // We now consider 'draft', 'setup', 'registration', and 'active' as non-completed/active UI
    const activeTournaments = filteredHistory.filter(t => t.status !== 'completed');

    // --- EVENT HANDLERS ---
    const deleteTournament = async (tournamentId) => {
        if (!window.confirm("Delete this tournament forever?")) return;
        try {
            await api.delete(`/tournaments/${tournamentId}`);
            setHistory(prev => prev.filter(t => t._id !== tournamentId));
        } catch (err) {
            console.error(err);
            alert("Error deleting tournament.");
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto space-y-10">
                
                {/* --- HEADER --- */}
                <header className="text-center space-y-2">
                    <h1 className="text-4xl font-black text-gray-900 tracking-tight">
                        Welcome, <span className="text-blue-600">{username}</span>! 🎮
                    </h1>
                    <p className="text-gray-500 font-medium">
                        {userRole === 'master' || userRole === 'admin' 
                            ? 'Create, manage, and track your tournament progress.' 
                            : 'Track your stats and view active tournaments.'}
                    </p>
                </header>

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                    
                    <div className="lg:col-span-1">
                        
                        {(userRole === 'master' || userRole === 'admin') ? (
                            // 👑 MASTER VIEW: THE WIZARDS
                            <div className="sticky top-10 flex flex-col gap-4"> 
                                {/* I wrapped both buttons in this flex-col div so React doesn't crash! */}
                                
                                {/* 1. Normal Tournament Button */}
                                <div className="bg-white rounded-3xl shadow-sm border border-gray-200 p-8 text-center flex flex-col items-center justify-center hover:shadow-md transition-shadow">
                                    <div className="w-16 h-16 bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mb-4 shadow-inner">
                                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                                        </svg>
                                    </div>
                                    <h3 className="text-xl font-black text-gray-900 mb-2">Host an Event</h3>
                                    <p className="text-gray-500 font-bold mb-6 text-sm">Launch a new tournament, league, or game night.</p>
                                    <button 
                                        onClick={() => navigate('/create-tournament')}
                                        className="w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-4 rounded-xl font-black shadow-lg shadow-blue-100 transition-transform active:scale-95"
                                    >
                                        CREATE TOURNAMENT
                                    </button>
                                </div>   

                                {/* 2. NEW: Circuit Button */}
                                <button 
                                    onClick={createCircuit}
                                    className="w-full bg-purple-50 hover:bg-purple-100 text-purple-700 border-2 border-dashed border-purple-300 px-6 py-4 rounded-xl font-black transition-colors flex justify-center items-center gap-2"
                                >
                                    <span className="text-xl">🏆</span>
                                    <span>Host a Championship Circuit</span>
                                </button>

                            </div>
                            
                        ) : (
// 🎮 PLAYER VIEW: THE GLOBAL PROFILE
<div className="space-y-6 sticky top-10">
    
    {/* MAIN STATS CARD */}
    <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-5 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
            <h3 className="font-black text-gray-800">Global Profile</h3>
            <span className="text-xl">📊</span>
        </div>
        <div className="p-6 space-y-4">
            <div className="flex justify-between items-center border-b border-gray-100 pb-3">
                <span className="text-gray-600 font-medium">Global Ranking</span>
                <span className="font-black text-blue-700 bg-blue-50 px-3 py-1 rounded-full text-sm">
                    {playerStats.overall.rankTitle}
                </span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3">
                <span className="text-gray-600 font-medium">Event Trophies 🏆</span>
                <span className="font-black text-xl text-gray-900">{playerStats.overall.tournamentWins}</span>
            </div>
            <div className="flex justify-between items-center border-b border-gray-100 pb-3">
                <span className="text-gray-600 font-medium">Total Match Points</span>
                <span className="font-black text-xl text-blue-600">{playerStats.overall.totalWinPts}</span>
            </div>
            <div className="flex justify-between items-center pb-2">
                <span className="text-gray-600 font-medium">Events Played</span>
                <span className="font-black text-xl text-gray-900">{playerStats.overall.tournamentsPlayed}</span>
            </div>
        </div>
    </div>

    {/* STATS BY GAME TYPE */}
    {Object.keys(playerStats.gameStats).length > 0 && (
        <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-100 bg-gray-50">
                <h3 className="font-black text-gray-800 text-sm uppercase tracking-widest">Performance by Game</h3>
            </div>
            <div className="p-2">
                {Object.entries(playerStats.gameStats).map(([game, stats]) => (
                    <div key={game} className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-xl transition-colors">
                        <span className="font-bold text-gray-700">{game}</span>
                        <div className="text-right">
                            <span className="block text-sm font-black text-blue-600">{stats.pts} Pts</span>
                            <span className="block text-[10px] text-gray-400 font-bold uppercase">{stats.played} Played • {stats.wins} Wins</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )}
</div>
                        )}

                    </div>

                    {/* --- RIGHT COLUMN: ACTIVE & HISTORY --- */}
                    <div className="lg:col-span-2 space-y-8">
                        
                        {/* SEARCH BAR */}
                        <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            <input 
                                type="text" 
                                placeholder="Search tournaments by name..." 
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl shadow-sm outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all font-medium text-gray-700"
                            />
                            {searchTerm && (
                                <button onClick={() => setSearchTerm('')} className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600">
                                    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            )}
                        </div>
{/* SEARCH BAR IS HERE... */}

                        {/* --- NEW: CIRCUITS SECTION --- */}
                        {circuits && circuits.length > 0 && (
                            <section className="animate-in fade-in slide-in-from-bottom-4">
                                <h2 className="text-xl font-black text-gray-800 mb-4 flex items-center gap-2">
                                    <span className="text-2xl">🏆</span>
                                    Championship Circuits
                                </h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {circuits.map(c => (
                                        <div 
                                            key={c._id} 
                                            onClick={() => navigate(`/circuit/${c._id}`)}
                                            className="relative bg-purple-50 p-5 rounded-2xl border border-purple-200 shadow-sm hover:shadow-md hover:border-purple-400 transition-all text-left group cursor-pointer"
                                        >
                                            <div className="flex justify-between items-start mb-2">
                                                <div className="bg-white text-purple-600 p-2 rounded-lg group-hover:bg-purple-600 group-hover:text-white transition-colors shadow-sm">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                                    </svg>
                                                </div>
                                                <span className="text-xs font-black text-purple-600 bg-white px-3 py-1 rounded-full uppercase shadow-sm">
                                                    {c.tournaments?.length || 0} Events
                                                </span>
                                            </div>
                                            <h3 className="font-black text-gray-900 group-hover:text-purple-700 transition-colors text-lg truncate">{c.name}</h3>
                                            <p className="text-sm text-purple-600/80 font-bold mt-1">Global Leaderboard Active</p>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        )}
                        {/* ACTIVE SECTION */}
                        <section>
                            <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                                <span className="flex h-3 w-3 rounded-full bg-green-500"></span>
                                Active Games
                            </h2>
                            {activeTournaments.length === 0 ? (
                                <div className="bg-white rounded-2xl p-8 border-2 border-dashed border-gray-200 text-center">
                                    <p className="text-gray-400">No active tournaments. Ready for a new challenge?</p>
                                </div>
                            ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {activeTournaments.map(t => (
                                        <div key={t._id} className="relative bg-white p-5 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md hover:border-blue-300 transition-all text-left group cursor-pointer">
                                            <div onClick={() => navigate(`/tournament/${t._id}`)}>
                                                <div className="flex justify-between items-start mb-4">
                                                    <div className="bg-blue-50 text-blue-600 p-2 rounded-lg group-hover:bg-blue-600 group-hover:text-white transition-colors">
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                                        </svg>
                                                    </div>
                                                    <span className="text-xs font-bold text-blue-600 bg-blue-50 px-2 py-1 rounded uppercase">
                                                        {t.status === 'draft' ? 'Draft' : t.status === 'active' ? `Round ${t.currentRound}` : t.status}
                                                    </span>
                                                </div>
                                                <h3 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors truncate">{t.name}</h3>
                                                <p className="text-sm text-gray-500">{t.players?.length || 0} Players</p>
                                            </div>
                                            {isAdmin && (
                                                <button onClick={(e) => { e.stopPropagation(); deleteTournament(t._id); }} className="absolute bottom-2 right-2 p-2 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-all">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </section>

{/* HISTORY SECTION */}
<section>
    <h2 className="text-xl font-black text-gray-800 mb-4 flex items-center gap-2">
        <span className="text-2xl">📜</span>
        {userRole === 'master' || userRole === 'admin' ? 'Past Tournaments' : 'My Tournament History'}
    </h2>
    <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden">
        
        {/* If Master/Admin, show the generic completed list like before */}
        {(userRole === 'master' || userRole === 'admin') ? (
            <div className="divide-y divide-gray-100">
                {completedTournaments.length === 0 ? (
                    <p className="p-8 text-center text-gray-400 italic">History will appear once tournaments are completed.</p>
                ) : (
                    completedTournaments.map(t => (
                        <div key={t._id} className="group relative flex items-center justify-between p-4 hover:bg-gray-50 transition-colors">
                            <div onClick={() => navigate(`/tournament/${t._id}/standings`)} className="flex items-center gap-4 flex-1 cursor-pointer">
                                <div className="text-2xl">🏆</div>
                                <div>
                                    <h4 className="font-bold text-gray-800">{t.name}</h4>
                                    <p className="text-xs text-gray-400 uppercase font-bold tracking-widest">{new Date(t.createdAt).toLocaleDateString()}</p>
                                </div>
                            </div>
                            <div className="flex items-center">
                                {isAdmin && (
                                    <button onClick={(e) => { e.stopPropagation(); deleteTournament(t._id); }} className="p-2 text-gray-300 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-all mr-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                                    </button>
                                )}
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                            </div>
                        </div>
                    ))
                )}
            </div>
        ) : (
            
            /* IF PLAYER, SHOW RICH PERSONAL HISTORY */
            <div className="divide-y divide-gray-100">
                
                {/* 1. Circuit History */}
                {playerStats.circuitHistory.map(c => (
                    <div key={c.id} onClick={() => navigate(`/circuit/${c.id}`)} className="flex items-center justify-between p-4 hover:bg-purple-50 cursor-pointer transition-colors bg-purple-50/30">
                        <div>
                            <div className="flex items-center gap-2 mb-1">
                                <span className="text-[10px] font-black uppercase tracking-widest bg-purple-100 text-purple-700 px-2 py-0.5 rounded">Circuit Event</span>
                            </div>
                            <h4 className="font-black text-gray-900">{c.name}</h4>
                        </div>
                        <div className="text-right flex items-center gap-4">
                            <div>
                                <span className="block text-sm font-black text-purple-600">{c.placement}{c.placement === 1 ? 'st' : c.placement === 2 ? 'nd' : c.placement === 3 ? 'rd' : 'th'} Place</span>
                                <span className="block text-[10px] text-gray-400 font-bold uppercase">{c.winPts} Pts • {c.totalPlayers} Players</span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                        </div>
                    </div>
                ))}

                {/* 2. Standard Tournament History */}
                {playerStats.tournamentHistory.length === 0 ? (
                    <p className="p-8 text-center text-gray-400 font-bold">You haven't completed any events yet.</p>
                ) : (
                    playerStats.tournamentHistory.map(t => (
                        <div key={t.id} onClick={() => navigate(`/tournament/${t.id}/standings`)} className="flex items-center justify-between p-4 hover:bg-blue-50 cursor-pointer transition-colors">
                            <div>
                                <h4 className="font-bold text-gray-800">{t.name}</h4>
                                <p className="text-[10px] text-gray-400 uppercase font-black tracking-widest">{t.game}</p>
                            </div>
                            <div className="text-right flex items-center gap-4">
                                <div>
                                    <span className={`block text-sm font-black ${t.placement === 1 ? 'text-yellow-600' : 'text-blue-600'}`}>
                                        {t.placement === 1 ? '🏆 1st Place' : `${t.placement}${t.placement === 2 ? 'nd' : t.placement === 3 ? 'rd' : 'th'} Place`}
                                    </span>
                                    <span className="block text-[10px] text-gray-400 font-bold uppercase">{t.winPts} Pts • {t.totalPlayers} Players</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                            </div>
                        </div>
                    ))
                )}
            </div>
        )}
    </div>
</section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;